import { useShallow } from 'zustand/react/shallow';
import React, { memo } from 'react';
import { css, type Theme } from '@emotion/react';
import { useUserStore } from 'common-state';
import { selectUserIsLoggedIn, selectUserDetails, selectUserPointBalance } from 'common-state/src/stores/userStore';
import { isRedemptionSite, formatUserPointsBalance } from '../../../utils/priceAndPointsConversion';
import ContainerLayout from '../../../layouts/ContainerLayout';

const pointBalanceStyle: (theme: Theme) => ReturnType<typeof css> = (theme: Theme) => css`
  display: none;
  background-color: #f3eef8;
  text-align: center;
  padding: 0.5em 1em;
  font-family: ${theme.fonts.familySecondary};
  font-size: ${theme.fonts.fontSize14};
  color: ${theme.colors.black};
  .points-banner-greeting {
    font-weight: ${theme.fonts.weightNormal};
  }
  .points-banner-balance {
    font-weight: ${theme.fonts.weightBold};
  }
  .sticky-header & {
    display: none;
  }
  ${theme.breakpoints.lg} {
    display: block;
  }
`;

export const PointsBanner = memo(() => {
  const isLoggedIn = useUserStore(selectUserIsLoggedIn);
  const userDetails = useUserStore(useShallow(selectUserDetails));
  const pointBalance = useUserStore(selectUserPointBalance);

  if (!isRedemptionSite() || !isLoggedIn || pointBalance === undefined) {
    return null;
  }

  const fullName = `${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`.trim();

  return (
    <div data-testid="points-banner" css={pointBalanceStyle} className="points-banner">
      <ContainerLayout className="text-right">
        <span className="points-banner-greeting">Hi {fullName},</span>{' '}
        <span className="points-banner-balance">{formatUserPointsBalance(pointBalance)} Velocity Points</span>
      </ContainerLayout>
    </div>
  );
});
